import { render } from "./TopicHeader.vue?vue&type=template&id=be77a7c8&scoped=true"
import script from "./TopicHeader.vue?vue&type=script&lang=js"
export * from "./TopicHeader.vue?vue&type=script&lang=js"

import "./TopicHeader.vue?vue&type=style&index=0&id=be77a7c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be77a7c8"]])

export default __exports__